import ShoppingCenter from './main';

const routes = [
  {
    path: '/*',
    Component: ShoppingCenter,
    props: {},
  },
  {
    path: '/:id/*',
    Component: ShoppingCenter,
    props: {},
  },
];

export default routes;
